/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungsaenderungsAntragDto } from '../../models/buchungsaenderungs-antrag-dto';
import { CreateBuchungsaenderungsAntragDto } from '../../models/create-buchungsaenderungs-antrag-dto';

export interface CreateBuchungsaenderungsAntrag$Plain$Params {

/**
 * ID der Buchung, für die der Antrag erstellt werden soll
 */
  buchungId: string;
  
    /**
     * Änderungsdaten für den Antrag
     */
    body?: CreateBuchungsaenderungsAntragDto
}

export function createBuchungsaenderungsAntrag$Plain(http: HttpClient, rootUrl: string, params: CreateBuchungsaenderungsAntrag$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BuchungsaenderungsAntragDto>> {
  const rb = new RequestBuilder(rootUrl, createBuchungsaenderungsAntrag$Plain.PATH, 'post');
  if (params) {
    rb.path('buchungId', params.buchungId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BuchungsaenderungsAntragDto>;
    })
  );
}

createBuchungsaenderungsAntrag$Plain.PATH = '/v1/buchungen/{buchungId}/aenderungsAntraege';
